import Legacy from '@/core/legacy'
import Views from '@/views'

// Import globals
import '@/store'
import './components'
import './directives'
import './filters'

// Import base style sheet
import "@/assets/css/base.less"

// Initialize the VUE instance
export default {
  mounted() {
    Legacy.init()
    Views.render(this.$el);
  }
};
